import styled from 'styled-components';

export const Container = styled.div`
  padding: 24px;
`;

export const ReturnCard = styled.div`
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ReturnHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
`;

export const ReturnInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ReturnStatus = styled.span<{ $state?: string }>`
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  padding: 4px 12px;
  border-radius: 9999px;
  font-size: 12px;
  font-weight: 500;
  background-color: ${({ $state }) => {
    switch ($state) {
      case 'completed':
        return '#DCFCE7';
      case 'confirmed':
        return '#DBEAFE';
      case 'awaiting_confirmation':
        return '#FEF3C7';
      case 'denied':
        return '#FEE2E2';
      default:
        return '#F3F4F6';
    }
  }};
  color: ${({ $state }) => {
    switch ($state) {
      case 'completed':
        return '#166534';
      case 'confirmed':
        return '#1D4ED8';
      case 'awaiting_confirmation':
        return '#B45309';
      case 'denied':
        return '#B91C1C';
      default:
        return '#374151';
    }
  }};
`;

export const ReturnId = styled.span`
  font-size: 12px;
  color: #6b7280;
  font-family: monospace;
`;

export const ReturnDetail = styled.div`
  font-size: 13px;
  color: #374151;
  margin-bottom: 4px;
`;

export const ReturnDetailLabel = styled.span`
  font-weight: 500;
  color: #6b7280;
`;

export const ShippingLabelLink = styled.a`
  font-size: 13px;
  font-weight: 500;
  color: #1d4ed8;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

export const EmptyState = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 32px;
  color: #6b7280;
  text-align: center;
`;
